import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { EntityMappingView } from './entity-mapping.view';
import { EntityMappingDataService } from './entity-mapping.data';

@observer
export class EntityMappingController extends React.Component<ControllerProps<any>, any> {
	@observable
	protected dataService: EntityMappingDataService;

	@resolve
	protected dialogService: DialogService;

	@resolve
	protected toast: ToastNotifications;

	constructor(props) {
		super(props);
		this.dataService = EntityMappingDataService.make();
		this.state = { mode: 'display' }
	}

	@autobind
	protected onModeChanged(mode: ControlMode) {
		this.setState({ mode: mode });
	}

	@autobind
	public async save() {
		const item = this.dataService.item;
		const errors = await item.validate(true);
		if (errors.length == 0) {
			this.props.setBusy(true);

			this.dataService.save()
				.then(() => {
					this.props.setBusy(false);
					this.toast.showDataSaved();
					this.dataService.reload()
						.then(() => {
							this.onModeChanged('display');
						})
				})
				.catch((error) => {
					this.props.setBusy(false);
					this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
				});
		} else {
			this.toast.showToast('Validation error!', errors.map(e => e.text), 'error');
		}
	}

	@autobind
	public cancel() {
		return new Promise<boolean>((resolve, reject) => {
			if (this.dataService.isDirty) {
				this.dialogService.showYesNo('Warning', 'Are you sure want to close this form? Your changes will be lost!')
					.then(dialogResult => {
						if (dialogResult) {
							this.dataService.reload()
								.then(() => {
									this.onModeChanged('display');
								})
						}
						resolve(true);
					})
					.catch(reject);
			} else {
				this.onModeChanged('display');
				resolve(true);
			}
		});
	}

	@autobind
	protected loadData() {
		this.props.setBusy(true);
		this.dataService.addFilter('isDeleted', 'eq', false);
		this.dataService.addSorting('id', 'asc', true);
		this.dataService.load(query => query)
			.catch(error => {
				this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
			})
			.then(() => {
				this.props.setBusy(false);
			});
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		if (this.dataService == null) {
			return null;
		}

		return (
			<EntityMappingView
				title="Mappings between Zulu's and External elements"
				mode={this.state.mode}
				onModeChanged={this.onModeChanged}
				cancel={this.cancel}
				save={this.save}
				model={this.dataService}
				setBusy={this.props.setBusy}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/entity-mappings/entity-mapping.controller.tsx